import { observable, action } from 'mobx';
import { IMyLink } from '../../../interfaces/IMyLink';
import { IFontSlots } from '../../../interfaces/IFontSlots';

export class MyLinksStore {

  ////////////////////////////////// Component properties //////////////////////////////////

  @observable public highlightColor: string;
  @observable public marginTop: number;
  @observable public displayType: "Standard" | "Condensed" | "Tiles";
  @observable public linkTextColor: string;
  @observable public linkIconColor: string;
  @observable public linkBackgroundColor: string;
  @observable public linkBorderRadius: string;
  @observable public linkDropShadow: boolean;
  @observable public linkBorderColor: string;
  @observable public linkBorderStyle: string;
  @observable public collapseCommandBarItems: boolean;
  @observable public defaultLinkIcon: string;
  @observable public hasDarkBackground: boolean;
  @observable public fontSlots: IFontSlots;


  ///////////////////////////////////////// Items /////////////////////////////////////////

  @observable public id: number;
  @observable public title: string;
  @observable public myLinks: IMyLink[];
  @observable public loading: boolean;
  @observable public isSaving: boolean;
  @observable public itemToEdit: IMyLink;
  @observable public itemToEditOriginal: IMyLink;
  @observable public itemToEditIndex: number;
  @observable public isCreatingNewItem: boolean;
  @observable public showCancelEditPopup: boolean;
  @observable public showDeletePopup: boolean;
  @observable public validUrl: boolean;
  @observable public editMode: boolean;

  @action public createNewItem(): void {
    this.isCreatingNewItem = true;
    this.itemToEdit = {
      icon: this.defaultLinkIcon ? this.defaultLinkIcon : "Arrow"
    };
  }

  @action public delete(): void {
    let selectedIndex: number;
    this.myLinks.forEach((item: IMyLink, index) => {
      if (item === this.itemToEdit) {
        selectedIndex = index;
      }     
    });
    this.myLinks.splice(selectedIndex, 1);
    this.itemToEdit = undefined;
    this.showDeletePopup = false;
  }

  ////////////////////////////////////// Drag'n'drop //////////////////////////////////////

  @observable public isDraggingItemWithIndex: number;
  @observable public draggedOverItemIndex: number;

  @action public addDroppableItemAtIndex(index: number) {
    console.log(index);
    // this.items.splice(index, 0, );
  }

  @action public isDraggingOverItemWithIndex(index: number) {
    if (index !== this.isDraggingItemWithIndex) {
      this.myLinks = this.swapArrayElements(this.myLinks, index, this.isDraggingItemWithIndex);
      this.isDraggingItemWithIndex = index;
    }
  }

  private swapArrayElements(a, x, y): any {
    if (a.length === 1) {
      return a;
    }
    a.splice(y, 1, a.splice(x, 1, a[y])[0]);
    return a;
  }

}